import { Link } from "react-router-dom";
import loginLogo from "../../../common/assets/images/logo.png";

type Props = {
    className?: string;
};
export default function Logo({ className }: Props) {
    return (
        <h1 className={className}>
            <Link
                to="/"
                className="inline-block w-[147px] h-[32px] indent-[-9999em] bg-cover bg-no-repeat"
                style={{ backgroundImage: `url(${loginLogo})` }}
            >
                고려원예
            </Link>
        </h1>
    );
}
